<template>
  <span
    style="display: inline-block;"
    ref="tooltip"
  >
    <slot/>
  </span>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'tooltip',
    props: {
      title: {
        type: String,
      },
      placement: {
        type: String,
        default: 'right',
      },
      delay: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      options () {
        return {
          animation: false,
          title: this.title,
          placement: this.placement,
          delay: {
            show: this.delay,
            hide: 0,
          },
        }
      },
    },
    methods: {
      init () {
        if (this.options.title) {
          $(this.$refs.tooltip).tooltip(this.options)
        } else {
          this.destroy()
        }
      },
      destroy () {
        $(this.$refs.tooltip).tooltip('dispose')
      },
      refresh () {
        this.$nextTick(() => {
          this.destroy()
          this.init()
        })
      },
    },
    mounted () {
      this.init()
    },
    beforeDestroy () {
      this.destroy()
    },
    watch: {
      options () {
        this.refresh()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/tooltip.vue